// extracted by mini-css-extract-plugin
export default {"header":"Header_header__jm--z","main-image":"Header_main-image__2rW-h"};